import { Component, Input, OnInit } from '@angular/core';
import { DATIQ_DEFAULT_EMPTY_LABEL } from '@dat/datiq-core/models';
import { IDatiqCellLane } from './models';

@Component({
    selector: 'datiq-cell-lane',
    templateUrl: './datiq-cell-lane.component.html',
    styleUrls: ['./datiq-cell-lane.component.scss'],
})
export class DatiqCellLaneComponent implements OnInit {
    @Input()
    settings: IDatiqCellLane;

    DEFAULT_LABEL = DATIQ_DEFAULT_EMPTY_LABEL;

    isOriginTruncated: boolean;
    isDestinationTruncated: boolean;

    constructor() {}

    ngOnInit(): void {
        this.isDestinationTruncated = false;
        this.isOriginTruncated = false;
    }
}
